import { PermissionT } from "../types";

export const platformConfig = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "platform_configuration");
  return !!p;
};

export default platformConfig;
